import React from 'react';
import { useTheme } from './hooks/useTheme';
import Navbar     from './components/Navbar';
import Hero       from './components/Hero';
import About      from './components/About';
import Skills     from './components/Skills';
import Projects   from './components/Projects';
import Experience from './components/Experience';
import Contact    from './components/Contact';
import Footer     from './components/Footer';
import './styles/global.css';

export default function App() {
  const { theme, toggle } = useTheme();

  return (
    <>
      <Navbar theme={theme} onToggleTheme={toggle} />

      <main>
        <Hero />
        <About />

        {/* Skills has its own full-bleed dark background */}
        <Skills />

        <Projects />
        <Experience />
        <Contact />
      </main>

      <Footer />
    </>
  );
}
